import {getCartPurchaseLines} from "@Common/logic/cart/get-cart-purchase-lines";
import {sum}                  from "@Common/utils/collections";

import {Summary} from "./common/summary/summary";

export const ReceiptSummary = ({cart}) => {
    const lines = getCartPurchaseLines(cart);

    return Summary({
        sections: [
            {
                lines,
            },
            {
                lines: [
                    {
                        label: "Purchase Total",
                        value: sum(lines, (t) => t.value),
                        big: true,
                    },

                    ...cart.appliedPayments?.billing?.map((b) => ({
                        label: "Billing Account: " + (b.name ?? ""),
                        value: b.amount,
                    }))||[],
                    ...cart.appliedPayments?.creditCards?.map((cc) => ({
                        label: "Used Credit Card: " + (cc.cardLast4 ? "**** **** **** " + cc.cardLast4 : ""),
                        value: +cc.amount,
                    }))||[],
                ],
            },
        ],
    });
};

